/**
 * Frontend feature-gate check that honors the 7-day Pro trial.
 *
 * The backend gates features via effective_feature_tier(tier,
 * pro_trial_started_at), which returns "paid" during an active trial.
 * Any frontend surface that checks `user.tier === "paid"` directly
 * silently denies trial users the features the backend would grant -
 * the exact bug that made the trial look fake (locked frequency chips,
 * 1-alert limit popups) while /pricing promised everything was open.
 *
 * Use THIS for feature gates. Keep raw `tier` checks only for
 * billing/subscription surfaces (plan badge, delete-account refund
 * warning) and for token/chat quota, which the trial deliberately does
 * NOT cover (anti-farming).
 */
export function hasProFeatures(
  u: { tier?: string; pro_preview_days_left?: number | null } | null | undefined,
): boolean {
  return !!u && (u.tier === "paid" || u.pro_preview_days_left != null);
}
